// Module
var code = `<div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">
                Toggle indexing state confirmation
            </h5>
            <button type="button" class="close" data-bind="click: cancel" aria-hidden="true">
                <i class="icon-cancel"></i>
            </button>
        </div>
        <div class="modal-body">
            <div><span data-bind="text: text"></span> all indexes on this database.</div>
            <div class="margin-top flex-horizontal alert alert-warning border-radius-xs">
                <div class="flex-start"><i class="icon-warning"></i></div>
                <div class="margin-left-xs">
                    After clicking <strong class="text-warning">Disable</strong>, the database must be reloaded in order for this indexing configuration to be in effect.<br>
                    Without reloading, the change will NOT apply (despite being written to the database record).
                </div>
            </div>
            <div class="margin-top-sm mb-0 alert alert-info border-radius-xs">
                <h4>There are two ways to reload the database:</h4>
                    <ul>
                        <li>
                            <small>
                                Disable and then enable the database from the databases view in the Studio.<br>
                                This will reload the database on all the cluster nodes immediately.
                            </small>
                        </li>
                        <li class="margin-top-xs">
                            <small>
                                Restart RavenDB on all nodes.<br>
                                The database settings configuration will become effective per node that is restarted.
                            </small>
                        </li>
                    </ul>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-default" data-bind="click: cancel">Cancel</button>
            <button type="button" class="btn btn-primary" data-bind="click: confirm, text: confirmText"></button>
        </div>
    </div>
</div>
`;
// Exports
export default code;